import Alpine from 'alpinejs';
Alpine.data('hero', () => ({
  scrollDown() {
    window.scrollBy({
      top: 780, // could be negative value
      left: 0,
      behavior: 'smooth'
    });
  },
}));
